
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.702","height":"15.369","viewBox":"0 0 24.702 25.369"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M22.24 8.7v15.071a1 1 0 01-1 1H1.598a1 1 0 01-1-1V4.126a1 1 0 011-1h13","stroke-width":"1.2","stroke":"#4e5d6b","stroke-miterlimit":"10","fill":"none"}}),_c('path',{attrs:{"d":"M22.713 5.153l-3.512-2.962a.2.2 0 01-.025-.285l.767-.909A1.4 1.4 0 0121.91.83l1.689 1.423a1.4 1.4 0 01.166 1.966l-.767.91a.2.2 0 01-.285.024z","stroke":"#4e5d6b","stroke-miterlimit":"10","fill":"none"}}),_c('path',{attrs:{"d":"M7.383 19.763a.2.2 0 01-.066-.2l1.291-5.1a.214.214 0 01.041-.081L19.172 1.903a.2.2 0 01.285-.024l3.513 2.962a.2.2 0 01.024.285L12.471 17.604a.207.207 0 01-.073.055l-4.8 2.135a.2.2 0 01-.215-.031z","fill":"#fff","stroke":"#4e5d6b","stroke-miterlimit":"10"}}),_c('path',{staticClass:"d",attrs:{"d":"M8.78 14.369l3.684 3.107M7.68 18.125l1.268 1.069"}})])
          )
        }
      }
    